@if (citizen(); as citizen) {
    <div mat-menu-item class="pseudo" disabled>
        <div>
            <mho-avatar [size]="40" [src]="citizen.avatar"></mho-avatar>
            <mho-citizen-info displayJob displayShunStatus [displayPseudoMode]="'simple'" [citizen]="citizen"></mho-citizen-info>
        </div>
    </div>
    <div mat-menu-item #statusTrigger="matMenuTrigger" [matMenuTriggerFor]="status" [role]="'menuitem'" (menuOpened)="closeOtherMenus('status')" i18n>États
    </div>
    <div mat-menu-item #bagTrigger="matMenuTrigger" [matMenuTriggerFor]="bag" [role]="'menuitem'" (menuOpened)="closeOtherMenus('bag')" i18n>Sac</div>
    <div mat-menu-item #dailyActionsTrigger="matMenuTrigger" [matMenuTriggerFor]="dailyActions" [role]="'menuitem'"
         (menuOpened)="openDailyActions()" i18n>Actions quotidiennes
    </div>
    <div mat-menu-item #heroicActionsTrigger="matMenuTrigger" [matMenuTriggerFor]="heroicActions" [role]="'menuitem'"
         (menuOpened)="closeOtherMenus('heroicActions')" i18n>Actions héroïques
    </div>
    <div mat-menu-item #homeTrigger="matMenuTrigger" class="home" [matMenuTriggerFor]="home" [role]="'menuitem'" (menuOpened)="closeOtherMenus('home')" i18n>
        Améliorations
    </div>
    <mat-menu #status (click)="$event.stopPropagation(); $event.preventDefault()" [xPosition]="'before'" [yPosition]="'below'"
              class="mho-menu-citizen-details statuses">
        <div class="status" (click)="$event.stopPropagation();">
            <mho-list-element-add-remove [currentList]="citizen.status?.icons || []" [lists]="status_lists"
                                         label="États" i18n-label
                                         addLabel="Ajouter aux états" i18n-addLabel
                                         (add)="addStatus($event + '')"
                                         removeLabel="Retirer des états" i18n-removeLabel
                                         (remove)="removeStatus($event + '')"
                                         emptyLabel="Vider les états"
                                         i18n-emptyLabel (empty)="emptyStatus()">
            </mho-list-element-add-remove>
        </div>
        <div class="chamanic band" (click)="$event.stopPropagation();">
            <mho-compact-stepper
                (valueChange)="changePotions($event)"
                [disabled]="!!citizen.chamanic_detail.is_immune_to_soul" [min]="0"
                [value]="citizen.chamanic_detail.nb_potion_shaman || 0"
                i18n-label
                icon="item/item_potion.gif"
                label="Potions bues">
            </mho-compact-stepper>
            <mho-compact-toggle
                (valueChange)="changeImmune($event)"
                [value]="citizen.chamanic_detail.is_immune_to_soul"
                i18n-label
                icon="icons/small_restoresp.gif"
                label="Immunisé">
            </mho-compact-toggle>
        </div>
    </mat-menu>
    <mat-menu #bag (click)="$event.stopPropagation(); $event.preventDefault()" [xPosition]="'before'" [yPosition]="'below'"
              class="mho-menu-citizen-details bag">
        <div (click)="$event.stopPropagation()">
            <mho-list-element-add-remove [currentList]="citizen.bag?.items || []" label="Sac" i18n-label withQuantity
                                         [lists]="bag_lists()"
                                         addLabel="Ajouter au sac" i18n-addLabel
                                         (add)="addItem(+$event)"
                                         removeLabel="Retirer du sac" i18n-removeLabel
                                         (remove)="removeItem(+$event)"
                                         emptyLabel="Vider le sac" i18n-emptyLabel
                                         (empty)="emptyBag()">
            </mho-list-element-add-remove>
        </div>
    </mat-menu>
    <mat-menu #dailyActions (click)="$event.stopPropagation(); $event.preventDefault()" [xPosition]="'before'" [yPosition]="'below'"
              class="mho-menu-citizen-details daily-actions">
        <div class="band" (click)="$event.stopPropagation();">
            @for (action of daily_action_keys(); track action.key) {
                <mho-compact-toggle
                    (valueChange)="saveDailyAction(action.key, $event)"
                    [icon]="action.value.img"
                    [label]="action.getLabel()"
                    [value]="isDailyActionDone(action.key)">
                </mho-compact-toggle>
            }
        </div>
    </mat-menu>
    <mat-menu #heroicActions (click)="$event.stopPropagation(); $event.preventDefault()" [xPosition]="'before'" [yPosition]="'below'"
              class="mho-menu-citizen-details heroic-actions">
        <div class="band" (click)="$event.stopPropagation();">
            @for (action of (citizen.heroic_actions?.content || []); track $index) {
                @if (action.element.value.max_lvl === 1) {
                    <mho-compact-toggle
                        (valueChange)="updateActions(action, $event)"
                        [icon]="getHeroicIcon(action)"
                        [label]="action.element.getLabel()"
                        [value]="$any(action.value)">
                    </mho-compact-toggle>
                }
            }
        </div>
        <div class="stepper-grid" (click)="$event.stopPropagation();">
            @for (action of (citizen.heroic_actions?.content || []); track $index) {
                @if (action.element.value.max_lvl > 1) {
                    <mho-compact-stepper
                        (valueChange)="updateActions(action, $event)"
                        [icon]="getHeroicIcon(action)"
                        [label]="action.element.getLabel()"
                        [max]="action.element.value.max_lvl"
                        [min]="0"
                        [value]="$any(action.value)">
                    </mho-compact-stepper>
                }
            }
        </div>
    </mat-menu>
    <mat-menu #home (click)="$event.stopPropagation(); $event.preventDefault()" [xPosition]="'before'" [yPosition]="'below'"
              class="mho-menu-citizen-details home">
        <div class="band" (click)="$event.stopPropagation();">
            @for (home of (citizen.home?.content || []); track $index) {
                @if (!isHomeEditable(home)) {
                    <!-- Niveau de maison : renseigné depuis MyHordes, jamais saisi. En tête de bande
                         puisqu'elle n'est pas modifiable, à côté des toggles. -->
                    <span [matTooltip]="home.element.getLabel()" class="home-readonly">
                        <img [alt]="home.element.getLabel()" [src]="HORDES_IMG_REPO + getHomeIcon(home)">
                        <span class="home-readonly-value">{{ home.value }}</span>
                    </span>
                }
            }
            @for (home of (citizen.home?.content || []); track $index) {
                @if (isHomeEditable(home) && home.element.value.max_lvl === 1) {
                    <mho-compact-toggle
                        (valueChange)="updateHome(home, $event)"
                        [icon]="home.element.value.img"
                        [label]="home.element.getLabel()"
                        [value]="$any(home.value)">
                    </mho-compact-toggle>
                }
            }
        </div>
        <div class="stepper-grid" (click)="$event.stopPropagation();">
            @for (home of (citizen.home?.content || []); track $index) {
                @if (isHomeEditable(home) && home.element.value.max_lvl > 1) {
                    <mho-compact-stepper
                        (valueChange)="updateHome(home, $event)"
                        [icon]="getHomeIcon(home)"
                        [label]="home.element.getLabel()"
                        [max]="home.element.value.max_lvl"
                        [min]="0"
                        [value]="$any(home.value)">
                    </mho-compact-stepper>
                }
            }
        </div>
    </mat-menu>
    <mat-divider></mat-divider>
}
